import React from 'react';

export const CognitoStateContent: React.FC = () => {
  return (
    <>
      <p className="mb-2">
        This action can be used to fix a broken Cognito state; It will attempt
        to re-create the user on Cognito with the correct attributes & groups.
      </p>
      <p className="mb-2">
        <strong className="font-medium">NOTE:</strong> If the status is
        'NotCreated' or 'Created' directly after creating a new user, you should
        give some time (several minutes) for our internal systems to initialize
        the user on Cognito with the correct attributes. If after some delay the
        user continues to have a non-synced state; you can use this action to
        attempt to fix it.
      </p>
      <p>
        If this action does not result in a fixed state; please report the case
        to the buyer team including the actions you took and the debug info
        shown below.
      </p>
    </>
  );
};
